import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { defaultDoc } from '../share/defaultDoc';
import type { ConditionRating } from './conditionRating.types';

export const conditionRatingPullQueryBuilder = (document: ConditionRating) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query conditionRatingFeed($lastRequested: DateTime) {
      conditionRatingFeed(lastRequested: $lastRequested) {
        name
        id
        discipline
        sort
        isActive
        dateModified
      }
    }
  `);

  return {
    query,
    variables: { lastRequested: doc?.dateModified },
  };
};
